import { FourierFilm } from "./FourierHeart";
import { invaderModel, pixelTransform } from "./invaderModel";
import { invaderPixels } from "./shapes/invader";
import { fourierConfig } from "./config";

const PixelInvader = () => (
  <g
    shapeRendering="crispEdges"
    transform={`scale(${pixelTransform.scale}) translate(${-pixelTransform.x} ${-pixelTransform.y})`}
    fill={fourierConfig.colors.trail}
  >
    {invaderPixels.flatMap((row, y) =>
      [...row].map((value, x) =>
        value === "1" ? (
          <rect key={`${x}-${y}`} x={x} y={y} width={1} height={1} />
        ) : null,
      ),
    )}
  </g>
);

export const FourierInvader = () => (
  <FourierFilm
    model={invaderModel}
    targetLabel="PIXEL INVADER"
    introText={["CIRCLES TO", "PIXEL ART?"]}
    teaser="ROUND MOTION. SQUARE PIXELS."
    centerFinal
    showCircleDetail
    finalArtwork={<PixelInvader />}
  />
);

